export default __webpack_public_path__ + "static/media/logo-medisurf.7f872b52.svg";